/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { ReactNode, useRef } from "react";

type ExpandableContainerProps = {
    isExpanded?: boolean;
    children: ReactNode;
    selector?: string;
    trigger: ReactNode;
}

export const ExpandableContainer = ({ isExpanded, children, trigger, selector }: ExpandableContainerProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const firstChildElement = (selector ? containerRef?.current?.querySelector(selector) : containerRef?.current?.firstChild);
    const maxHeight = firstChildElement instanceof HTMLElement ? firstChildElement?.offsetHeight : 0;
    const containerHeight = containerRef?.current?.offsetHeight ?? 0;
    const hasMultipleRows = containerHeight / maxHeight >= 2;

    return (
        <div>
            <div css={css`${isExpanded ? "" : `max-height: ${maxHeight ? `${maxHeight + 1}px;` : "fit-content;"}; overflow: hidden;`}`}>
                <div ref={containerRef} >
                    {children}
                </div>
            </div>

            {hasMultipleRows && trigger}
        </div>
    );
};
